var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("div", { staticClass: "centered-div" }, [
          _c("h3", { staticClass: "register-text" }, [
            _c("b", [
              _vm._v(
                "Register for " +
                  _vm._s(_vm.isGDPR ? "DataMapper GDPR" : "DataMapper")
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.success
          ? _c("div", { staticClass: "success-text" }, [
              _c("h3", { staticClass: "success-h3" }, [
                _vm._v("Success! We're sending you an invite.")
              ]),
              _vm._v(" "),
              _vm._m(0)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.userExistsError
          ? _c("signup-error", { on: { hide: _vm.disableUserExistsError } })
          : _vm._e(),
        _vm._v(" "),
        !_vm.success
          ? _c("div", [
              _c("div", { staticClass: "grid" }, [
                _c("div", { staticClass: "centered-div" }, [
                  _c(
                    "form",
                    {
                      staticClass: "register-form",
                      on: {
                        submit: [
                          _vm.createUser,
                          function($event) {
                            $event.preventDefault()
                            _vm.noRefresh($event)
                          }
                        ]
                      }
                    },
                    [
                      _c("div", { staticClass: "email-label-text" }, [
                        _vm._v(
                          "\n                    Email\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.email,
                            expression: "email"
                          }
                        ],
                        attrs: { type: "email", placeholder: "your@email.com" },
                        domProps: { value: _vm.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.email = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "validation-block" }, [
                        !_vm.$v.email.required && _vm.submitted
                          ? _c("p", [_vm._v("The email field is required.")])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.$v.email.email && _vm.submitted
                          ? _c("p", [_vm._v("The email must be valid.")])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", { staticClass: "invite-text" }, [
                        _vm._v(
                          "\n                    You will receive an invite to " +
                            _vm._s(
                              _vm.isGDPR ? "DataMapper GDPR " : "DataMapper"
                            ) +
                            " after registering\n                    "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "register-button",
                      on: { click: _vm.createUser }
                    },
                    [_vm._v("continue")]
                  ),
                  _vm._v(" "),
                  _vm._m(1)
                ])
              ])
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "success-body-text" }, [
      _vm._v(
        "\n            Just follow the link in the email\n            and you will be organizing "
      ),
      _c("br"),
      _vm._v(" your documents in no time!\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "terms-text" }, [
      _vm._v(
        "\n                    By signing up I agree to DataMapper's\n                    "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://bysafeonline.com/connectid-datamapper-terms-of-use/",
            target: "_blank"
          }
        },
        [_vm._v("Terms of Use")]
      ),
      _vm._v("\n                     and\n                    "),
      _c(
        "a",
        {
          attrs: {
            href: "https://bysafeonline.com/connectid-datamapper-resources",
            target: "_blank"
          }
        },
        [_vm._v("Privacy Policy")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bac04678", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bac04678","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./apps/account/Register.vue
// module id = 534
// module chunks = 0